module.exports = __webpack_public_path__ + "img/PAMMAccountLogo2.68a552f0.svg";